<script>
export default {
	props: ['showModal', 'isOpen'],
};
</script>

<template>
	<div class="flex flex-col sm:flex-row sm:items-center sm:gap-1">
		<router-link
			to="/projects"
			class="font-general-medium px-3 py-2 rounded-lg text-sm transition-all duration-200 text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-slate-400 dark:hover:text-white dark:hover:bg-white/5"
			:class="$route.path === '/projects' ? 'active-link' : ''"
			aria-label="Projects"
		>
			Projects
		</router-link>

		<router-link
			to="/about"
			class="font-general-medium px-3 py-2 rounded-lg text-sm transition-all duration-200 text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-slate-400 dark:hover:text-white dark:hover:bg-white/5"
			:class="$route.path === '/about' ? 'active-link' : ''"
			aria-label="About Me"
		>
			About
		</router-link>

		<router-link
			to="/contact"
			class="font-general-medium px-3 py-2 rounded-lg text-sm transition-all duration-200 text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-slate-400 dark:hover:text-white dark:hover:bg-white/5"
			:class="$route.path === '/contact' ? 'active-link' : ''"
			aria-label="Contact"
		>
			Contact
		</router-link>
	</div>
</template>

<style scoped>
.active-link {
	color: #f59e0b !important;
	background: rgba(245, 158, 11, 0.1);
}
</style>
